import { useEffect, useState } from "react";
import type { VolunteerHistoryPayload } from "../types/volunteer";
import { apiGet } from "./api";

interface State {
  data: VolunteerHistoryPayload | null;
  error: string | null;
  loading: boolean;
}

export function useVolunteer(id: string | undefined): State {
  const [state, setState] = useState<State>({
    data: null,
    error: null,
    loading: true,
  });

  useEffect(() => {
    if (!id) {
      setState({ data: null, error: "missing volunteer id", loading: false });
      return;
    }
    let cancelled = false;
    apiGet<VolunteerHistoryPayload>(`/volunteers/${id}`)
      .then((data) => {
        if (!cancelled) setState({ data, error: null, loading: false });
      })
      .catch((err: Error) => {
        if (!cancelled) setState({ data: null, error: err.message, loading: false });
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  return state;
}
